import { css } from 'linaria';
import { styled } from 'linaria/react';

const yandexBackgroundColor = '#f5f7f9';
const yandexButtonColor = '#edeff2';
const yandexBorderRadius = '20px';

export const yandexSplitContainer = css`
  display: flex;
  align-items: flex-start;
  align-self: stretch;
  border: 0;
  justify-content: flex-start;
  position: relative;
  height: 124px;

  & > *:first-child {
    gap: var(--space-100);
  }
`;

export const yandexSplitWidget = css`
  height: 124px;
  width: 100%;
  z-index: 100;
`;

export const hidden = css`
  display: none;
`;

export const additionalMarginTop = css`
  margin-top: var(--space-200);
`;

export const additionalMarginBottom = css`
  margin-bottom: var(--space-100);
`;

export const SkeletonContainer = styled.div<{
  isSet?: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 124px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  padding: var(--space-250);
  background-color: ${yandexBackgroundColor};
  border-radius: ${yandexBorderRadius};
  gap: var(--space-100);
  margin-top: ${(props) => (props.isSet ? 'var(--space-200)' : '0')};
`;

export const skeletonBase = css`
  background-color: ${yandexButtonColor};
  border-radius: var(--rounding-l);
  padding: 0 !important;
`;

export const skeletonInnerContainer = css`
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  width: 100%;
  flex-direction: column;
  gap: var(--space-150);
  padding: var(--space-225);
`;

export const firstSkeleton = css`
  width: 250px;
  height: 36px !important;
  margin-right: auto;
`;

export const secondSkeleton = css`
  width: 100%;
  height: 36px !important;
  margin-right: auto;
`;
